import { render, staticRenderFns } from "./NumeroProcessoInput.vue?vue&type=template&id=fce9948c&"
import script from "./NumeroProcessoInput.vue?vue&type=script&lang=js&"
export * from "./NumeroProcessoInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports